<template>
  <section class="policy-item">
    <span v-if="news" class="common-positive-negative mr-8" :class="[`is-${data.sensitivity}`]">
      <span>{{sentiment}} {{thePercent}}</span>
    </span>
    <span v-else class="area">{{data.province}}</span>
    <div class="content">
      <div class="title" @click="clickHandle">
        <span :title="data.title">{{data.title}}</span>
        <span class="time" v-if="news">{{data.pubdate}}</span>
        <span class="time" v-else>{{data.time}}</span>
      </div>
      <div v-if="news" class="sub-title">新闻来源：{{data.site}}</div>
      <div v-else class="sub-title">{{data.releaseOrganization}}</div>

      <div class="tag-panel" v-if="showTag && data.tags">
        <span class="policy-tag" v-for="item in data.tags" :key="item">{{item}}</span>
      </div>
    </div>
    <template v-if="news">
      <DialogNewsDetail v-if="dialogShow !== null" ref="newsDetail" :show.sync="dialogShow" :data="data" />
    </template>
    <template v-else>
      <DialogPolicyDetail v-if="dialogShow !== null" ref="newsDetail" :show.sync="dialogShow" :data="data" />
    </template>
  </section>
</template>

<script>

import DialogPolicyDetail from './dialogPolicyDetail.vue'
import DialogNewsDetail from '@/views/industryChainNew/components/dialogNewsDetail'
export default {
  name: 'textDocument',
  components: {
    DialogPolicyDetail,
    DialogNewsDetail
  },
  props: {
    news: {
      type: Boolean,
      default: false
    },
    showTag: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      dialogShow: null
    }
  },
  computed: {
    sentiment() {
      const sensitivity = {
        neutral: '中性',
        positive: '正面',
        negative: '负面',
      }
      return sensitivity[this.data?.sensitivity || 'neutral']
    },
    thePercent() {
      if (this.data?.confidence !== null) {
        return this.data.confidence + '.00%'
      }
      return '--'
    },
  },
  mounted() {
  },
  methods: {
    clickHandle() {
      this.dialogShow = true
    }
  },
};
</script>

<style scoped lang="scss">
section.policy-item {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  padding-bottom: 18px;
}
section.policy-item .area {
  font-size: 12px;
  font-weight: 400;
  color: #186bfc;
  padding: 4px 8px;
  border-radius: 2px;
  margin-right: 16px;
  width: 70px;
  text-align: center;
  border: 1px solid #186bfc;
}

section.policy-item .content {
  flex: 1;
  overflow: hidden;
}
section.policy-item .title {
  display: flex;
  align-items: center;
}
section.policy-item .title > :first-child {
  font-size: 16px;
  font-weight: 600;
  color: #1b253a;
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  cursor: pointer;
}
section.policy-item .title .time {
  font-size: 12px;
  font-weight: 400;
  color: #b6bed0;
  margin-left: 16px;
}
section.policy-item .sub-title {
  font-size: 14px;
  font-weight: 400;
  color: #333;
  margin-top: 6px;
}
section.policy-item .tag-panel {
  display: flex;
  align-items: center;
  align-content: flex-start;
  flex-direction: row;
  flex-wrap: wrap;
}
section.policy-item .tag-panel .policy-tag {
  font-size: 14px;
  font-weight: 400;
  color: #186bfc;
  background: rgba(24, 107, 252, 0.16);
  border-radius: 2px;
  padding: 4px 8px;
  margin-right: 8px;
  margin-top: 6px;
}
</style>
